import React, { useState, useEffect } from 'react';
import { getQuestions, getQuestionById, submitDraft } from '../services/writingService';
import '../styles/WritingPage.css';

function QuestionSelector({ questions, selectedId, onSelect }) {
  return (
    <aside className="sidebar">
      <ul className="question-list">
        {questions.map(q => (
          <li
            key={q.id}
            className={q.id === selectedId ? 'active' : ''}
            onClick={() => onSelect(q.id)}
          >
            {q.title} ({q.difficulty})
          </li>
        ))}
      </ul>
    </aside>
  );
}

function InstructionBar({ instructions }) {
  return (
    <header className="top-panel">
      <h2>Instructions</h2>
      <p>{instructions}</p>
    </header>
  );
}

function TextEditor({ draft, onChange, wordLimit }) {
  const words = draft.trim() ? draft.trim().split(/\s+/).length : 0;
  return (
    <section className="editor">
      <textarea
        className="editor-textarea"
        value={draft}
        onChange={e => onChange(e.target.value)}
        placeholder="Write your response here..."
      />
      <div className="word-count">
        {words}/{wordLimit} words
      </div>
    </section>
  );
}

function FeedbackPanel({ feedback }) {
  if (!feedback) return null;
  return (
    <aside className="feedback-panel">
      <h2>Feedback</h2>
      <ul>
        {feedback.comments.map((c, i) => (
          <li key={i}>{c}</li>
        ))}
      </ul>
      <div className="token-usage">Tokens used: {feedback.tokens_used}</div>
    </aside>
  );
}

export default function WritingPage() {
  const [questions, setQuestions] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [detail, setDetail] = useState(null);
  const [draft, setDraft] = useState('');
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    async function load() {
      const data = await getQuestions();
      setQuestions(data.questions);
    }
    load();
  }, []);

  useEffect(() => {
    if (!selectedId) return;
    async function loadDetail() {
      const res = await getQuestionById(selectedId);
      setDetail(res.question);
      setDraft('');
      setFeedback(null);
    }
    loadDetail();
  }, [selectedId]);

  const handleSubmit = async () => {
    if (!draft.trim()) return;
    const res = await submitDraft(selectedId, draft);
    setFeedback(res.feedback);
  };

  return (
    <div className="writing-page">
      {detail && <InstructionBar instructions={detail.instructions} />}
      <div className="content-area">
        <QuestionSelector
          questions={questions}
          selectedId={selectedId}
          onSelect={setSelectedId}
        />

        {detail ? (
          <>
            <TextEditor
              draft={draft}
              onChange={setDraft}
              wordLimit={detail.word_limit}
            />
            <button
              type="button"
              className="submit-btn"
              onClick={handleSubmit}
              disabled={!draft.trim()}
            >
              Submit
            </button>
            <FeedbackPanel feedback={feedback} />
          </>
        ) : (
          <div className="placeholder">
            Select a question to begin writing.
          </div>
        )}
      </div>
    </div>
  );
}